<template>
    <div class="w-full flex flex-col items-center">
        <img
            src="@/assets/img/graphics/eskd/diagnostic-algorithm-desktop.svg"
            alt="PH1 Diagnostic Algorithm"
            class="hidden md:block"
        />
        <img
            src="@/assets/img/graphics/eskd/diagnostic-algorithm-mobile.svg"
            alt="PH1 Diagnostic Algorithm"
            class="md:hidden"
        />
    </div>
</template>
